import { render, staticRenderFns } from "./UblArchiveFromUrl.vue?vue&type=template&id=26cef850&scoped=true"
import script from "./UblArchiveFromUrl.vue?vue&type=script&lang=ts"
export * from "./UblArchiveFromUrl.vue?vue&type=script&lang=ts"
import style0 from "./UblArchiveFromUrl.vue?vue&type=style&index=0&id=26cef850&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cef850",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26cef850')) {
      api.createRecord('26cef850', component.options)
    } else {
      api.reload('26cef850', component.options)
    }
    module.hot.accept("./UblArchiveFromUrl.vue?vue&type=template&id=26cef850&scoped=true", function () {
      api.rerender('26cef850', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UblArchiveFromUrl.vue"
export default component.exports